export default {
  baseStyle: {
    whiteSpace: 'normal',
    maxW: '320px',
    wordBreak: 'break-word',
    bg: 'blueGrey.800',
    borderRadius: '8px',
    padding: '12px',
    fontSize: '12px',
    color: 'white',
    fontFamily: 'Rubik',
    arrowShadowColor: 'blueGrey.800',
    '--popper-arrow-bg': 'colors.blueGrey.800',
  },
};
